import { useEffect } from 'react';
import { gql, useLazyQuery } from '@apollo/client';

import useSuspenseQuery from 'commons/useSuspenseQuery';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useProductBasicDetails from '../useProductBasicDetails';
import { GET_MODULAR_SOFA_BUNDLE } from '../useModularPDPState/queries';

const GET_IS_MODULAR_BUNDLE_PRODUCT = gql`
  query getIsModularBundleOrPreconfigProduct($id: Int) {
    getIsModularBundleOrPreconfigProduct(id: $id) {
      productType
      isInModular
    }
  }
`;

const useModularDetails = (slug = null) => {
  const {
    loading: productBasicLoading,
    error: productBasicError,
    data: productBasicData = {},
  } = useProductBasicDetails(null, slug);

  const { data, error, loading } = useSuspenseQuery(
    GET_IS_MODULAR_BUNDLE_PRODUCT,
    {
      variables: { id: productBasicData?.id },
      skip: !productBasicData?.id,
      context: { noBatch: true },
    }
  );

  const [getModularBundleData, { data: modularBundleData }] = useLazyQuery(
    GET_MODULAR_SOFA_BUNDLE
  );

  useEffect(() => {
    if (
      !productBasicData?.slug ||
      !data?.getIsModularBundleOrPreconfigProduct?.isInModular
    ) {
      return;
    }
    const finalSlug = productBasicData.meta.collectionSlug
      ? productBasicData.meta.collectionSlug.replace('collections/', '')
      : null;
    if (
      !finalSlug ||
      (modularBundleData?.modularBundle?.modular_parent?.slug || '').includes(
        finalSlug
      )
    ) {
      return;
    }
    getModularBundleData({
      variables: {
        slug: `${finalSlug}-modular`,
        ...getVisitorLocationQueryVariables(),
      },
    });
  }, [
    data?.getIsModularBundleOrPreconfigProduct?.isInModular,
    productBasicData?.meta,
    modularBundleData,
    getModularBundleData,
    productBasicData?.slug,
  ]);

  return {
    loading: productBasicLoading || loading,
    error: productBasicError || error,
    data: {
      isModular: data?.getIsModularBundleOrPreconfigProduct?.isInModular,
      isModularBundleProduct:
        data?.getIsModularBundleOrPreconfigProduct?.productType === 'Bundle',
      isModularPreConfigProduct:
        data?.getIsModularBundleOrPreconfigProduct?.productType === 'Preconfig',
      preConfigProducts:
        modularBundleData?.modularBundle?.preConfiguredProducts,
    },
  };
};

export default useModularDetails;
